import type React from 'react';
import { RiCalendarEventLine } from '@itandi/itandi-bb-ui';
import Styles from './InspectionCandidateDatesList.module.scss';
import type { Deal } from '~/models/Deal';
import { formatDate } from '~/utils/DateUtil';
import type { InspectionCandidateDate } from '~/models/InspectionCandidateDate';

type Props = {
  deal: Deal;
};

/**
 * 入居者からの希望日程一覧
 *
 * @for client, vendor
 */

export const InspectionCandidateDatesList: React.FC<Props> = ({
  deal
}: Props) => {
  const { dealInspectionCandidateDates: candidateDates } = deal;
  if (candidateDates.length === 0) return null;
  return (
    <div className={Styles.InspectionCandidateDates}>
      <h3 className={Styles.CandidateTitle}>
        <RiCalendarEventLine className={Styles.Icon} />
        入居者からの希望日程
      </h3>
      {candidateDates.map(
        (candidateDate: InspectionCandidateDate): React.ReactNode => (
          <div key={candidateDate.id} className={Styles.CandidateDateRow}>
            <span className={Styles.Title}>第{candidateDate.sort}希望</span>
            <span className={Styles.Date}>
              {formatDate(candidateDate.date)}
            </span>
            {candidateDate.time}
          </div>
        )
      )}
    </div>
  );
};
